module.exports = __webpack_public_path__ + "img/beach.4610709.webp";